export default __webpack_public_path__ + "static/media/g.c9fd5f19.png";